var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"","width":"35","showModal":_vm.showModal},on:{"close-modal":_vm.closeModal}},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }